import React from 'react';

import css from './FiltersColumn.module.css';
import FeedCountryFilter from '../FeedCountryFilter/FeedCountryFilter';
import FeedTypeFilter from '../FeedTypeFilter/FeedTypeFilter';
import FeedEntityFilter from '../FeedEntityFilter/FeedEntityFilter';
import FeedIndustryFilterWrapper from '../FeedIndustryFilterWrapper/FeedIndustryFilterWrapper';

const Filters = () => {
  return (
    <div className={css.main}>
      <FeedEntityFilter />
      <FeedTypeFilter />
      <FeedIndustryFilterWrapper />
      <FeedCountryFilter />
    </div>
  );
};

export default Filters;
